import "./ElectricalTechnician.module.css";
import Header from "@/reusable_sections/Header";
import LocalVisibilityProblem from "./sections/LocalVisibilityProblem";
import CourseDetails from "./sections/CourseDetails";
import ServiceCategories from "./sections/ServiceCategories";
import Footer from "@/reusable_sections/Footer";
export default function ElectricalTechnicianPage() {
  return <div>
      <Header />
      <LocalVisibilityProblem />
      <CourseDetails />
      <ServiceCategories />
      <Footer />
    </div>;
}